import { deriveViewState, type ViewState } from '@/modules/session/deriveViewState';
import { type PortalDeposit } from '@/schemas/cashierSession.schema';
import { type CashierMethodTile } from '@/schemas/methods.schema';

import { type SessionState } from './types';

export function selectViewState(state: SessionState): ViewState {
  return deriveViewState({
    phase: state.phase,
    status: state.deposit?.status ?? null,
    mode: state.deposit?.mode ?? null,
    methods: state.tiles,
    walletInstructions: state.walletInstructions,
    expiresAt: state.deposit?.expiresAt ?? null,
    error: state.error,
    clientIntent: state.clientIntent,
  });
}

export function selectAmountParts(state: SessionState): {
  amount: string;
  currency: string;
  receivedAmount: string | null;
} | null {
  const deposit = state.deposit;
  if (deposit === null) return null;
  return {
    amount: deposit.amount,
    currency: deposit.currency,
    receivedAmount: deposit.receivedAmount,
  };
}

/** The catalogue as returned by methods — both `api` and `wallet` tiles. */
export function selectVisibleTiles(state: SessionState): CashierMethodTile[] | null {
  return state.tiles;
}

export function selectDeposit(state: SessionState): PortalDeposit | null {
  return state.deposit;
}
